import { libraryCardSx } from '../../../designTokens';
import {
  libraryCardAuthorSx,
  libraryCardMetaSx,
  libraryCardTitleSlotSx,
} from '../../shared/prompt-display/libraryCardSlotStyles';

export const discoveryCardSx = {
  ...libraryCardSx,
  p: 1.75,
  borderRadius: '8px',
  bgcolor: 'background.paper',
  cursor: 'pointer',
};

export const discoveryTitleSx = {
  ...libraryCardTitleSlotSx(),
  flexGrow: 0,
};

export const discoveryAuthorSx = libraryCardAuthorSx;
export const discoveryMetaSx = libraryCardMetaSx;
